"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SceCompressedProperties_1 = require("./SceCompressedProperties");
var Field_1 = require("../../constants/Field");
var uuid_1 = require("uuid");
var lodash_1 = require("lodash");
var Objects_1 = require("../../api/Objects");
var ModelConstants_1 = require("../../constants/ModelConstants");
var EngineeringModel_1 = require("../../api/enggModel/EngineeringModel");
var SceCompressedModel = /** @class */ (function () {
    function SceCompressedModel() {
        this._objectsAPI = new Objects_1.Objects();
        this._enggModelApi = new EngineeringModel_1.EngineeringModel();
    }
    SceCompressedModel.fromJson = function (json, isInstance) {
        var sceCompressedModel = new SceCompressedModel();
        sceCompressedModel.model = json[Field_1.FIELD.MODEL];
        sceCompressedModel.type = isInstance ? ModelConstants_1.ModelConstants.SceInstanceType : ModelConstants_1.ModelConstants.SceType;
        sceCompressedModel.version = json[Field_1.FIELD.VERSION];
        sceCompressedModel.objectId = json[Field_1.FIELD.OBJECTID];
        sceCompressedModel.properties = SceCompressedProperties_1.SceCompressedProperties.fromJson(json[Field_1.FIELD.PROPERTIES][Field_1.FIELD.MODELS]);
        return sceCompressedModel;
    };
    SceCompressedModel.createSceCompressedJson = function (jsons, isInstance) {
        var sceCompressedModel = new SceCompressedModel();
        sceCompressedModel.model = isInstance ? ModelConstants_1.ModelConstants.SceInstanceModel : ModelConstants_1.ModelConstants.SceModel;
        sceCompressedModel.type = isInstance ? ModelConstants_1.ModelConstants.SceInstanceType : ModelConstants_1.ModelConstants.SceType;
        if (isInstance) {
            if (!jsons[0].objectId) {
                throw new Error("objectId not defined for instance");
            }
            sceCompressedModel.objectId = jsons[0].objectId;
        }
        else {
            if (jsons[0].version) {
                sceCompressedModel.version = jsons[0].version;
            }
            sceCompressedModel.objectId = jsons[0].objectId ? jsons[0].objectId : uuid_1.v4();
        }
        sceCompressedModel.properties = new SceCompressedProperties_1.SceCompressedProperties();
        console.log("inside createSceCompressedJson", sceCompressedModel);
        console.log("inside createSceCompressedJson - jsons", jsons);
        lodash_1.map(jsons, function (json) {
            var model = json.properties.model;
            sceCompressedModel.properties.addModel(model.model.value, model.typeId.value, model.version.value, model.name.value, json);
        });
        return sceCompressedModel;
    };
    SceCompressedModel.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.MODEL] = this.model;
        json[Field_1.FIELD.TYPE] = this.type;
        if (this.version) {
            json[Field_1.FIELD.VERSION] = this.version;
        }
        json[Field_1.FIELD.OBJECTID] = this.objectId;
        json[Field_1.FIELD.PROPERTIES] = this.properties.toJson();
        return json;
    };
    /**
     *
     * @param isInstance If true, objectId will be used as storageId,
     * else asset monitor typeId will be used as storageId
     */
    SceCompressedModel.prototype.saveCompressedModel = function (isInstance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, json;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._objectsAPI.deleteObject(this.objectId, this.model)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 3:
                        json = this.toJson();
                        if (!isInstance) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._enggModelApi.StoreEnggModel(json, this.objectId)];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5: return [4 /*yield*/, this._enggModelApi.StoreEnggModel(json, this.objectId, this.properties.models[0].model.value, this.properties.models[0].typeId.value, this.properties.models[0].version.value)];
                    case 6: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    SceCompressedModel.prototype.saveCompressedModelToInfoModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        json = this.toJson();
                        return [4 /*yield*/, this._objectsAPI.saveObject(JSON.stringify(json))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SceCompressedModel.prototype.updateCompressedModel = function (isInstance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var updatedJson, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedJson = this.toJson();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.deleteCompressedModelFromInfoModel()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!isInstance) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._enggModelApi.UpdateEnggModel(updatedJson, this.objectId)];
                    case 5: return [2 /*return*/, _b.sent()];
                    case 6: return [4 /*yield*/, this._enggModelApi.UpdateEnggModel(updatedJson, this.objectId, this.properties.models[0].model.value, this.properties.models[0].typeId.value, this.properties.models[0].version.value)];
                    case 7: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    SceCompressedModel.prototype.deleteCompressedModel = function (isInstance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, _a, response, response;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 7]);
                        return [4 /*yield*/, this.deleteCompressedModelFromInfoModel()];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                    case 2:
                        _a = _b.sent();
                        if (!isInstance) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(this.objectId, this.model)];
                    case 3:
                        response = _b.sent();
                        return [2 /*return*/, response];
                    case 4: return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(this.objectId, this.model, this.properties.models[0].model.value, this.properties.models[0].typeId.value)];
                    case 5:
                        response = _b.sent();
                        return [2 /*return*/, response];
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SceCompressedModel.prototype.deleteCompressedModelFromInfoModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._objectsAPI.deleteObject(this.objectId, this.model)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return SceCompressedModel;
}());
exports.SceCompressedModel = SceCompressedModel;
//# sourceMappingURL=SceCompressedModel.js.map